import React from "react";
import {SetStateAction, useCallback, useContext, useEffect, useMemo, useRef, useState} from "react";
import {
    Button,
    DatePickerField,
    // Input,
    InputField,
    LionProgressbar,
    Typography
} from "@bezlimit/bezlimit-ui";
import {MobXProviderContext, observer} from "mobx-react";
import {Col, Form, Row} from "@bezlimit/bezlimit-ui";
import type {UploadFile} from "antd/es/upload/interface";
import _ from "lodash";
import "./style.scss";
// components
import UploadBtn from "./uploadBtn";
import {useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {locale, Moment} from "moment";
import moment from "moment";
import {Input, Upload} from "antd";
import Title from "../title";
import {PlusOutlined} from "@ant-design/icons";
import Store from "../../../../../stores";
//core
import Axios, {axiosFetchBuilder, IAxiosConfig} from "../../../../../core/Axios";
import {LayoutContext, ModalContext} from "../../../../../core/Contexts";
import {IErrors} from "../../../../../core/models/Error";
//images
import passportFrontImg from "../../../../../images/passport_front.svg";
import passportRegImg from "../../../../../images/passport_reg.png";
import imeiSvg from "../../../../../images/fall2.svg";
//modal
import ErrorPassportAdd from "../../../../modal/errorPassportAdd";
import InfoImeiModal from "../../../../modal/infoImei";
import ErrorSignUrl from "../../../../modal/errorSignUrl";
import SuccessSignUrl from "../../../../modal/successSignUrl";
import SuccessAddPassport from "../../../../modal/successAddPassport";
//services
import ReservationsService from "../../../../../services/ReservationsService";
//fields
import CheckboxField from "../../../../fields/checkbox";
import AddressField from "../../../../fields/address2";
import RadioField from "../../../../fields/radio";
//components
import Loading from "../../../../blocks/ui/loading";
import DefaultPortal from "../../../../portals/default";

const datePickerProps: any = {
    allowClear: false,
    format: "DD.MM.YYYY",
    showToday: false,
    locale: locale("ru"),
    disabledDate: (current: Moment) =>
        current.isSameOrBefore(moment("1930-01-01")) || current.isAfter(moment())
};

const rules = [{required: true, message: "Поле обязательно для заполнения"}];

export default observer(function PassportForm() {
    const contextLayout = useContext(LayoutContext);
    const contextModal = useContext(ModalContext);
    const {store} = useContext(MobXProviderContext);
    const timeout = useRef<NodeJS.Timeout>();
    const [form] = Form.useForm();
    const [passportFront, setPassportFront] = useState<UploadFile<any>[]>();
    const [passportReg, setPassportReg] = useState<UploadFile<any>[]>();
    const [passportRegDisable, setPassportRegDisable] = useState(true);
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loadingAddress, setLoadingAddress] = useState(false);
    const [progress, setProgress] = useState(0);
    const [searchParams] = useSearchParams();
    const [options, setOptions] = useState<any[]>([]);
    const [addresses, setAddresses] = useState<any[]>([]);
    const [handwrite, setHandwrite] = useState(false);
    const [data, setData] = useState<any>();

    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const ref = useRef<any>(null);

    const onCancellInfoImeiModal = () => {
        contextModal?.setMaskStyle(undefined);
        contextModal?.setCssClass("");
        contextModal?.setVisible(false);
    };

    const onClickInfoImei = () => {
        contextModal?.setMaskStyle({
            background: "rgba(0, 0, 0, 0.40)",
            // @ts-ignore
            WebkitBackdropFilter: " blur(31px)",
            backdropFilter: " blur(31px)"
        });
        contextModal?.setCssClass(" bl-modal-info-imei");
        contextModal?.setChildren(<InfoImeiModal />);
        contextModal?.setVisible(true);
        contextModal?.setOnCancel(() => onCancellInfoImeiModal);
    };

    const onCancelSign = async () => {
        try {
            const phone = searchParams.get("phone");
            let num = Number(phone);

            const response: any = await ReservationsService.getReservationsByPnone(
                {
                    phone_number: num,
                    status: _.isEqual(Store.reservations.activeKey, "activation") ? "activated" : ""
                },
                true
            );

            const reservations = _.get(response, "items[0]");

            await Axios({
                url: "/reservations/passport",
                method: "PUT",
                data: {
                    lastname: _.get(reservations, "phone.abonentPassport.firstname"),
                    firstname: _.get(reservations, "phone.abonentPassport.firstname"),
                    patroname: _.get(reservations, "phone.abonentPassport.patroname"),
                    birthday: _.get(reservations, "phone.abonentPassport.birthday"),
                    gender: _.get(reservations, "phone.abonentPassport.gender"),
                    birth_place_name: _.get(reservations, "phone.abonentPassport.birth_place_name"),
                    document_series: _.isEqual(data?.document_type, "domestic")
                        ? _.get(reservations, "phone.abonentPassport.document_series")
                        : "",
                    passport_nomer: _.get(reservations, "phone.abonentPassport.passport_nomer"),
                    division_code: _.isEqual(data?.document_type, "domestic")
                        ? _.get(reservations, "phone.abonentPassport.division_code")
                        : "",
                    passport_kogda_vidan: _.get(
                        reservations,
                        "phone.abonentPassport.passport_kogda_vidan"
                    ),
                    passport_vidan: _.get(reservations, "phone.abonentPassport.passport_vidan"),
                    place_name: _.get(reservations, "phone.abonentPassport.place_name"),
                    street_name: _.get(reservations, "phone.abonentPassport.street_name"),
                    house: _.get(reservations, "phone.abonentPassport.house"),
                    building_name: !_.isNil(
                        _.get(reservations, "phone.abonentPassport.building_name")
                    )
                        ? _.get(reservations, "phone.abonentPassport.building_name")
                        : "-",
                    apartment_name: _.get(reservations, "phone.abonentPassport.apartment_name"),
                    imei: _.isEqual(data?.document_type, "domestic")
                        ? "-"
                        : _.get(reservations, "phone.abonentPassport.imei"),
                    phone: _.get(reservations, "phone_number"),
                    status: "declined"
                }
            } as IAxiosConfig);

            navigate(
                `/signature/step1?id=${_.get(reservations, "tariff.id")}&phone=${_.get(
                    reservations,
                    "phone_number"
                )}`
            );

            contextModal?.setMaskStyle(undefined);
            contextModal?.setCssClass("");
            contextModal?.setVisible(false);
        } catch (error) {}
    };

    const onCancel = () => {
        contextModal?.setMaskStyle(undefined);
        contextModal?.setCssClass("");
        contextModal?.setVisible(false);
        navigate(`/reservation`);
    };

    const getReservation = async (loading = false) => {
        const phone = searchParams.get("phone");
        let num = Number(phone);

        try {
            const response: any = await ReservationsService.getReservationsByPnone(
                {
                    phone_number: num,
                    status: _.isEqual(Store.reservations.activeKey, "activation") ? "activated" : ""
                },
                loading
            );

            if (
                loading &&
                !_.isEqual(response.items[0]?.phone.passport, null) &&
                !_.isEqual(response.items.length, 0)
            ) {
                setPassportFront([
                    {
                        status: "success",
                        thumbUrl: response.items[0]?.phone.abonentPassport?.photos?.front?.url
                    }
                ] as any);
                !_.isEqual(response.items[0]?.phone?.abonentPassport?.photos?.back, null) &&
                    setPassportReg([
                        {
                            status: "success",
                            thumbUrl: response.items[0]?.phone?.abonentPassport?.photos?.back?.url
                        }
                    ] as any);
            }

            const abonentPassport = _.get(response, "items[0].phone.abonentPassport");
            setData(_.get(response, "items[0].phone.abonentPassport"));

            if (abonentPassport) {
                if (!_.isNil(_.get(abonentPassport, "lastname"))) {
                    form.setFieldValue("lastname", _.get(abonentPassport, "lastname"));
                }
                if (!_.isNil(_.get(abonentPassport, "firstname"))) {
                    form.setFieldValue("firstname", _.get(abonentPassport, "firstname"));
                }

                if (!_.isNil(_.get(abonentPassport, "patroname"))) {
                    form.setFieldValue("patroname", _.get(abonentPassport, "patroname"));
                }

                if (!_.isNil(_.get(abonentPassport, "birthday"))) {
                    form.setFieldValue("birthday", moment(_.get(abonentPassport, "birthday")));
                }

                if (!_.isNil(_.get(abonentPassport, "gender"))) {
                    form.setFieldValue("gender", _.get(abonentPassport, "gender"));
                }

                if (!_.isNil(_.get(abonentPassport, "birth_place_name"))) {
                    form.setFieldValue(
                        "birth_place_name",
                        _.get(abonentPassport, "birth_place_name")
                    );
                }

                // form.setFieldValue("nationality", "Россия");

                if (!_.isNil(_.get(abonentPassport, "document_series"))) {
                    form.setFieldValue(
                        "document_series",
                        _.get(abonentPassport, "document_series")
                    );
                }

                if (!_.isNil(_.get(abonentPassport, "passport_nomer"))) {
                    form.setFieldValue("passport_nomer", _.get(abonentPassport, "passport_nomer"));
                }

                if (!_.isNil(_.get(abonentPassport, "division_code"))) {
                    form.setFieldValue("division_code", _.get(abonentPassport, "division_code"));
                }

                if (!_.isNil(_.get(abonentPassport, "passport_kogda_vidan"))) {
                    form.setFieldValue(
                        "passport_kogda_vidan",
                        moment(_.get(abonentPassport, "passport_kogda_vidan"))
                    );
                }

                if (!_.isNil(_.get(abonentPassport, "passport_vidan"))) {
                    form.setFieldValue("passport_vidan", _.get(abonentPassport, "passport_vidan"));
                }

                if (!_.isNil(_.get(abonentPassport, "imei"))) {
                    form.setFieldValue("imei", _.get(abonentPassport, "imei"));
                }

                let address = "";

                if (!_.isNil(_.get(abonentPassport, "place_name"))) {
                    address = `${_.get(abonentPassport, "place_name")}`;
                    form.setFieldValue("place_name", _.get(abonentPassport, "place_name"));
                }

                if (!_.isNil(_.get(abonentPassport, "street_name"))) {
                    address += `, ${_.get(abonentPassport, "street_name")}`;
                    form.setFieldValue("street_name", _.get(abonentPassport, "street_name"));
                }

                if (!_.isNil(_.get(abonentPassport, "house"))) {
                    address += `, д ${_.get(abonentPassport, "house")}`;
                    form.setFieldValue("house", _.get(abonentPassport, "house"));
                }

                if (
                    !_.isNil(_.get(abonentPassport, "building_name")) &&
                    !_.startsWith(_.trim(_.get(abonentPassport, "building_name")), "-")
                ) {
                    address += `, ст ${_.get(abonentPassport, "building_name")}`;
                    form.setFieldValue("building_name", _.get(abonentPassport, "building_name"));
                }

                if (!_.isNil(_.get(abonentPassport, "apartment_name"))) {
                    address += `, кв ${_.get(abonentPassport, "apartment_name")}`;
                    form.setFieldValue("apartment_name", _.get(abonentPassport, "apartment_name"));
                }

                form.setFieldValue("fullAdress", address);

                axiosFetchBuilder<{items: any[]}>({
                    url: "/system/addresses",
                    params: {
                        query: address,
                        expand: "detail"
                    },
                    loading
                })
                    .then((res) => {
                        const options = _.chain(res.items)
                            .reduce<{value: string; label: string}[]>((res, i) => {
                                (res || (res = [])).push({value: i.value, label: i.value});
                                return res;
                            }, [])
                            .valueOf();
                        setOptions(options);
                        setAddresses(res.items);
                    })
                    .finally(() => {
                        setLoadingAddress(false);
                    });

                setTimeout(() => {
                    if (!_.isNil(_.get(abonentPassport, "lastname"))) {
                        ref.current?.querySelector(".field-lastname")?.classList.add("focused");
                    }
                    if (!_.isNil(_.get(abonentPassport, "firstname"))) {
                        ref.current?.querySelector(".field-firstname")?.classList.add("focused");
                    }

                    if (!_.isNil(_.get(abonentPassport, "patroname"))) {
                        ref.current?.querySelector(".field-patroname")?.classList.add("focused");
                    }

                    if (!_.isNil(_.get(abonentPassport, "birthday"))) {
                        ref.current?.querySelector(".field-birthday")?.classList.add("focused");
                    }

                    if (!_.isNil(_.get(abonentPassport, "gender"))) {
                        ref.current?.querySelector(".field-gender")?.classList.add("focused");
                    }

                    if (!_.isNil(_.get(abonentPassport, "birth_place_name"))) {
                        ref.current
                            ?.querySelector(".field-birth_place_name")
                            ?.classList.add("focused");
                    }

                    if (!_.isNil(_.get(abonentPassport, "document_series"))) {
                        ref.current
                            ?.querySelector(".field-document_series")
                            ?.classList.add("focused");
                    }

                    if (!_.isNil(_.get(abonentPassport, "passport_nomer"))) {
                        ref.current
                            ?.querySelector(".field-passport_nomer")
                            ?.classList.add("focused");
                    }

                    if (!_.isNil(_.get(abonentPassport, "division_code"))) {
                        ref.current
                            ?.querySelector(".field-division_code")
                            ?.classList.add("focused");
                    }

                    if (!_.isNil(_.get(abonentPassport, "passport_kogda_vidan"))) {
                        ref.current
                            ?.querySelector(".field-passport_kogda_vidan")
                            ?.classList.add("focused");
                    }

                    if (!_.isNil(_.get(abonentPassport, "passport_vidan"))) {
                        ref.current
                            ?.querySelector(".field-passport_vidan")
                            ?.classList.add("focused");
                    }

                    if (!_.isNil(_.get(abonentPassport, "place_name"))) {
                        ref.current?.querySelector(".field-place_name")?.classList.add("focused");
                    }

                    if (!_.isNil(_.get(abonentPassport, "street_name"))) {
                        ref.current?.querySelector(".field-street_name")?.classList.add("focused");
                    }

                    if (!_.isNil(_.get(abonentPassport, "house"))) {
                        ref.current?.querySelector(".field-house")?.classList.add("focused");
                    }

                    if (!_.isNil(_.get(abonentPassport, "building_name"))) {
                        ref.current
                            ?.querySelector(".field-building_name")
                            ?.classList.add("focused");
                    }

                    if (!_.isNil(_.get(abonentPassport, "apartment_name"))) {
                        ref.current
                            ?.querySelector(".field-apartment_name")
                            ?.classList.add("focused");
                    }

                    if (!_.isNil(_.get(abonentPassport, "imei"))) {
                        ref.current?.querySelector(".field-imei")?.classList.add("focused");
                    }

                    if (!!_.trim(address)) {
                        ref.current?.querySelector(".field-fullAdress")?.classList.add("focused");
                    }
                }, 2000);
            }

            return response;
        } catch (e) {
            throw e;
        }
    };

    const onSearch = useMemo(() => {
        const loadOptions = (searchText: string) => {
            if (searchText) {
                if (_.find(addresses, (i) => _.includes(i.label, searchText))) {
                    setOptions(_.filter(addresses, (i) => _.includes(i.label, searchText)));
                } else {
                    cb(searchText);
                }
            } else {
                setOptions([]);
                setAddresses([]);
            }
        };

        return _.debounce(loadOptions, 300);
    }, [options, addresses, 300]);

    const cb = useCallback(async (address: string) => {
        setLoadingAddress(true);
        axiosFetchBuilder<{items: any[]}>({
            url: "/system/addresses",
            params: {
                query: address,
                expand: "detail"
            },
            loading: false
        })
            .then((res) => {
                const options = _.chain(res.items)
                    .reduce<{value: string; label: string}[]>((res, i) => {
                        (res || (res = [])).push({value: i.value, label: i.value});
                        return res;
                    }, [])
                    .valueOf();
                setOptions(options);
                setAddresses(res.items);
            })
            .finally(() => {
                setLoadingAddress(false);
            });
    }, []);

    const onFinish = async (values: any) => {
        try {
            setLoading2(true);

            await Axios({
                url: "/reservations/passport",
                method: "PUT",
                loading: false,
                data: {
                    lastname: values.lastname,
                    firstname: values.firstname,
                    patroname: values.patroname,
                    birthday: values.birthday.format("YYYY-MM-DD"),
                    gender: values.gender,
                    birth_place_name: values.birth_place_name,
                    document_series: _.isEqual(data?.document_type, "domestic")
                        ? values.document_series
                        : "",
                    passport_nomer: values.passport_nomer,
                    division_code: _.isEqual(data?.document_type, "domestic")
                        ? values.division_code
                        : "",
                    passport_kogda_vidan: values.passport_kogda_vidan.format("YYYY-MM-DD"),
                    passport_vidan: values.passport_vidan,
                    place_name: values.place_name,
                    street_name: values.street_name,
                    house: values.house,
                    building_name: values.building_name ? values.building_name : "-",
                    apartment_name: values.apartment_name,
                    imei: _.isEqual(data?.document_type, "domestic") ? "-" : values.imei,
                    phone: searchParams.get("phone"),
                    status: "confirmed"
                }
            } as IAxiosConfig);
            const res: any = await getReservation(false);

            const contract = _.find(_.get(res, "items[0].phone.docs"), (i) =>
                _.isEqual(i?.code, "contract")
            );

            // let url;
            // if (
            //     _.isEqual(res?.items[0]?.verification, "doc_sign") &&
            //     !_.isEqual(res?.items[0]?.sign_url, "")
            // ) {
            //     url = new URL(res?.items[0]?.sign_url);
            // }

            if (_.isEqual(res?.items[0]?.verification, "done")) {
                contextModal?.setMaskStyle({
                    background:
                        "linear-gradient(0deg, rgba(100, 40, 120, 0.20) 0%, rgba(100, 40, 120, 0.20) 100%), rgba(0, 0, 0, 0.65)",
                    // @ts-ignore
                    WebkitBackdropFilter: " blur(12px)",
                    backdropFilter: " blur(12px)"
                });
                contextModal?.setCssClass(" bl-modal-success-passport-add");
                contextModal?.setChildren(<SuccessAddPassport />);
                contextModal?.setVisible(true);
                contextModal?.setOnCancel(() => onCancel);
            } else if (_.isEqual(res?.items[0]?.verification, "sign")) {
                let url;

                if (!_.isEqual(res?.items[0]?.sign_url, "")) {
                    url = new URL(res?.items[0]?.sign_url);
                }

                contextModal?.setMaskStyle({
                    background:
                        "linear-gradient(0deg, rgba(100, 40, 120, 0.20) 0%, rgba(100, 40, 120, 0.20) 100%), rgba(0, 0, 0, 0.65)",
                    // @ts-ignore
                    WebkitBackdropFilter: " blur(12px)",
                    backdropFilter: " blur(12px)"
                });
                contextModal?.setCssClass(" bl-modal-success-passport-add");
                contextModal?.setChildren(
                    <SuccessSignUrl link={_.get(contract, "link")} url={url} />
                );
                contextModal?.setVisible(true);
                contextModal?.setOnCancel(() => onCancelSign);
            }
            // else if (url?.pathname) {
            //     navigate(`${url?.pathname}${location.search ?? ""}`);
            // }
            else {
                contextModal?.setMaskStyle({
                    background:
                        "linear-gradient(0deg, rgba(100, 40, 120, 0.20) 0%, rgba(100, 40, 120, 0.20) 100%), rgba(0, 0, 0, 0.65)",
                    // @ts-ignore
                    WebkitBackdropFilter: " blur(12px)",
                    backdropFilter: " blur(12px)"
                });
                contextModal?.setCssClass(" bl-modal-success-passport-add");
                contextModal?.setChildren(<ErrorSignUrl />);
                contextModal?.setVisible(true);
                contextModal?.setOnCancel(() => onCancel);
            }
        } catch (e: any) {
            const response = _.get(e, "response");

            if (
                response &&
                _.isEqual(_.get(response, "status"), 422) &&
                !!_.size(_.get(response, "data"))
            ) {
                form.setFields(
                    _.chain(_.get(response, "data"))
                        .reduce<IErrors[]>((res, i) => {
                            (res || (res = [])).push({
                                name: i.field,
                                errors: [i.message]
                            });
                            return res;
                        }, [])
                        .valueOf()
                );

                if (
                    !!_.find(_.get(response, "data"), ({field}) =>
                        _.includes(
                            [
                                "place_name",
                                "street_name",
                                "house",
                                "building_name",
                                "apartment_name"
                            ],
                            field
                        )
                    )
                ) {
                    form.setFieldValue("fullAdress", "");
                    form.setFieldValue("handwrite", ["true"]);
                    setHandwrite(true);
                }

                setTimeout(() => {
                    if (!!form.getFieldValue("lastname")) {
                        ref.current?.querySelector(".field-lastname")?.classList.add("focused");
                    } else {
                        ref.current?.querySelector(".field-lastname")?.classList.remove("focused");
                    }

                    if (!!form.getFieldValue("firstname")) {
                        ref.current?.querySelector(".field-firstname")?.classList.add("focused");
                    } else {
                        ref.current?.querySelector(".field-firstname")?.classList.remove("focused");
                    }

                    if (!!form.getFieldValue("patroname")) {
                        ref.current?.querySelector(".field-patroname")?.classList.add("focused");
                    } else {
                        ref.current?.querySelector(".field-patroname")?.classList.remove("focused");
                    }

                    if (!!form.getFieldValue("birthday")) {
                        ref.current?.querySelector(".field-birthday")?.classList.add("focused");
                    } else {
                        ref.current?.querySelector(".field-birthday")?.classList.remove("focused");
                    }

                    if (!!form.getFieldValue("gender")) {
                        ref.current?.querySelector(".field-gender")?.classList.add("focused");
                    } else {
                        ref.current?.querySelector(".field-gender")?.classList.remove("focused");
                    }

                    if (!!form.getFieldValue("birth_place_name")) {
                        ref.current
                            ?.querySelector(".field-birth_place_name")
                            ?.classList.add("focused");
                    } else {
                        ref.current
                            ?.querySelector(".field-birth_place_name")
                            ?.classList.remove("focused");
                    }

                    if (!!form.getFieldValue("document_series")) {
                        ref.current
                            ?.querySelector(".field-document_series")
                            ?.classList.add("focused");
                    } else {
                        ref.current
                            ?.querySelector(".field-document_series")
                            ?.classList.remove("focused");
                    }

                    if (!!form.getFieldValue("passport_nomer")) {
                        ref.current
                            ?.querySelector(".field-passport_nomer")
                            ?.classList.add("focused");
                    } else {
                        ref.current
                            ?.querySelector(".field-passport_nomer")
                            ?.classList.remove("focused");
                    }

                    if (!!form.getFieldValue("division_code")) {
                        ref.current
                            ?.querySelector(".field-division_code")
                            ?.classList.add("focused");
                    } else {
                        ref.current
                            ?.querySelector(".field-division_code")
                            ?.classList.remove("focused");
                    }

                    if (!!form.getFieldValue("passport_kogda_vidan")) {
                        ref.current
                            ?.querySelector(".field-passport_kogda_vidan")
                            ?.classList.add("focused");
                    } else {
                        ref.current
                            ?.querySelector(".field-passport_kogda_vidan")
                            ?.classList.remove("focused");
                    }

                    if (!!form.getFieldValue("passport_vidan")) {
                        ref.current
                            ?.querySelector(".field-passport_vidan")
                            ?.classList.add("focused");
                    } else {
                        ref.current
                            ?.querySelector(".field-passport_vidan")
                            ?.classList.remove("focused");
                    }

                    if (!!form.getFieldValue("imei")) {
                        ref.current?.querySelector(".field-imei")?.classList.add("focused");
                    } else {
                        ref.current?.querySelector(".field-imei")?.classList.remove("focused");
                    }

                    if (!!form.getFieldValue("place_name")) {
                        ref.current?.querySelector(".field-place_name")?.classList.add("focused");
                    } else {
                        ref.current
                            ?.querySelector(".field-place_name")
                            ?.classList.remove("focused");
                    }

                    if (!!form.getFieldValue("street_name")) {
                        ref.current?.querySelector(".field-street_name")?.classList.add("focused");
                    } else {
                        ref.current
                            ?.querySelector(".field-street_name")
                            ?.classList.remove("focused");
                    }

                    if (!!form.getFieldValue("house")) {
                        ref.current?.querySelector(".field-house")?.classList.add("focused");
                    } else {
                        ref.current?.querySelector(".field-house")?.classList.remove("focused");
                    }

                    if (!!form.getFieldValue("fullAdress")) {
                        ref.current?.querySelector(".field-fullAdress")?.classList.add("focused");
                    } else {
                        ref.current
                            ?.querySelector(".field-fullAdress")
                            ?.classList.remove("focused");
                    }

                    if (!!form.getFieldValue("building_name")) {
                        ref.current
                            ?.querySelector(".field-building_name")
                            ?.classList.add("focused");
                    } else {
                        ref.current
                            ?.querySelector(".field-building_name")
                            ?.classList.remove("focused");
                    }

                    if (!!form.getFieldValue("apartment_name")) {
                        ref.current
                            ?.querySelector(".field-apartment_name")
                            ?.classList.add("focused");
                    } else {
                        ref.current
                            ?.querySelector(".field-apartment_name")
                            ?.classList.remove("focused");
                    }
                }, 1000);
            }

            throw e;
        } finally {
            setLoading2(false);
        }
    };

    const isVisible = (values?: any) => {
        const front = !!values ? values?.passportFront : passportFront;
        const reg = !!values ? values?.passportReg : passportReg;

        return (
            !!front &&
            !!reg &&
            _.isEqual(_.get(front, "[0].status"), "success") &&
            _.isEqual(_.get(reg, "[0].status"), "success")
        );
    };

    const isPassportRegDisable = () => {
        if (!passportFront) {
            return true;
        }

        if (!!passportFront && _.isEqual(_.get(passportFront, "[0].status"), "error")) {
            return true;
        }
    };

    const setPhoto = async (
        file: UploadFile,
        values: any,
        setter: React.Dispatch<SetStateAction<UploadFile<any>[] | undefined>>
    ) => {
        const side = isPassportRegDisable() ? "front" : "back";

        switch (file.status) {
            case "removed":
                setter(undefined);
                break;
            default:
                try {
                    clearTimeout(timeout.current);
                    _startProgress();

                    await Axios({
                        url: "/reservations/passport-photo",
                        method: "POST",
                        loading: false,
                        data: {
                            side: side,
                            phone: searchParams.get("phone"),
                            photo: file.originFileObj
                        }
                    } as IAxiosConfig);
                    _.set(file, "status", "success");

                    if (
                        isVisible({
                            passportFront: values?.passport_front?.fileList,
                            passportReg: values?.passport_reg?.fileList
                        })
                    ) {
                        await getReservation(false);
                    }
                    await getReservation(false);
                } catch (e: any) {
                    _.set(file, "status", "error");
                    contextModal?.setMaskStyle({
                        background:
                            "linear-gradient(0deg, rgba(100, 40, 120, 0.20) 0%, rgba(100, 40, 120, 0.20) 100%), rgba(0, 0, 0, 0.65)",
                        // @ts-ignore
                        WebkitBackdropFilter: " blur(12px)",
                        backdropFilter: " blur(12px)"
                    });
                    contextModal?.setCssClass(" bl-modal-error-passport-add");
                    contextModal?.setChildren(<ErrorPassportAdd />);
                    contextModal?.setVisible(true);

                    throw e;
                } finally {
                    setter([file]);
                    _stopProgress();
                }

                break;
        }
    };

    const onValuesChange = (value: any, values: any) => {
        const key = _.first(_.keys(value));

        if (key && _.trim(_.get(value, key))) {
            form.setFields([{name: key, errors: []}]);
        }

        if ("passport_front" in value) {
            if (_.isEqual(value.passport_front?.file?.status, "removed")) {
                setPassportRegDisable(true);
            } else {
                setPassportRegDisable(false);
            }

            setPhoto(value.passport_front.file, values, setPassportFront);
        } else if ("passport_reg" in value) {
            setPhoto(value.passport_reg.file, values, setPassportReg);
        } else if ("fullAdress" in value) {
            const address = _.find(addresses, (i) => _.isEqual(i.value, value.fullAdress));

            if (address && !_.isNil(address.detail)) {
                form.setFieldValue("apartment_name", _.get(address, "detail.apartment_name"));
                form.setFieldValue("building_name", _.get(address, "detail.building_name"));
                form.setFieldValue("house", _.get(address, "detail.house"));
                form.setFieldValue("place_name", _.get(address, "detail.place_name"));
                form.setFieldValue("street_name", _.get(address, "detail.street_name"));

                if (!_.get(address, "detail.apartment_name")) {
                    ref.current
                        ?.querySelector(".field-apartment_name")
                        ?.classList.remove("focused");
                }
                if (!_.get(address, "detail.building_name")) {
                    ref.current?.querySelector(".field-building_name")?.classList.remove("focused");
                }
                if (!_.get(address, "detail.house")) {
                    ref.current?.querySelector(".field-house")?.classList.remove("focused");
                }
                if (!_.get(address, "detail.place_name")) {
                    ref.current?.querySelector(".field-place_name")?.classList.remove("focused");
                }
                if (!_.get(address, "detail.street_name")) {
                    ref.current?.querySelector(".field-street_name")?.classList.remove("focused");
                }
            } else {
                form.setFieldValue("apartment_name", "");
                form.setFieldValue("building_name", "");
                form.setFieldValue("house", "");
                form.setFieldValue("place_name", "");
                form.setFieldValue("street_name", "");

                ref.current?.querySelector(".field-apartment_name")?.classList.remove("focused");
                ref.current?.querySelector(".field-building_name")?.classList.remove("focused");
                ref.current?.querySelector(".field-house")?.classList.remove("focused");
                ref.current?.querySelector(".field-place_name")?.classList.remove("focused");
                ref.current?.querySelector(".field-street_name")?.classList.remove("focused");
            }
        } else if ("handwrite" in value) {
            setHandwrite(!!_.size(_.get(value, "handwrite")));

            if (!!_.get(values, "place_name")) {
                ref.current?.querySelector(".field-place_name")?.classList.add("focused");
            } else {
                ref.current?.querySelector(".field-place_name")?.classList.remove("focused");
            }

            if (!!_.get(values, "street_name")) {
                ref.current?.querySelector(".field-street_name")?.classList.add("focused");
            } else {
                ref.current?.querySelector(".field-street_name")?.classList.remove("focused");
            }

            if (!!_.get(values, "house")) {
                ref.current?.querySelector(".field-house")?.classList.add("focused");
            } else {
                ref.current?.querySelector(".field-house")?.classList.remove("focused");
            }

            if (!!_.get(values, "building_name")) {
                ref.current?.querySelector(".field-building_name")?.classList.add("focused");
            } else {
                ref.current?.querySelector(".field-building_name")?.classList.remove("focused");
            }

            if (!!_.get(values, "apartment_name")) {
                ref.current?.querySelector(".field-apartment_name")?.classList.add("focused");
            } else {
                ref.current?.querySelector(".field-apartment_name")?.classList.remove("focused");
            }
        }

        if (
            _.includes(
                ["apartment_name", "building_name", "house", "place_name", "street_name"],
                key
            )
        ) {
            let address = "";

            if (!!_.get(values, "place_name")) {
                address += _.get(values, "place_name");
            }

            if (!!_.get(values, "street_name")) {
                address += `, ${_.get(values, "street_name")}`;
            }

            if (!!_.get(values, "house")) {
                address += `, д ${_.get(values, "house")}`;
            }

            if (!!_.get(values, "building_name")) {
                address += `, ст ${_.get(values, "building_name")}`;
            }

            if (!!_.get(values, "apartment_name")) {
                address += `, кв ${_.get(values, "apartment_name")}`;
            }

            form.setFieldValue("fullAdress", address);

            if (address) {
                ref.current?.querySelector(".field-fullAdress")?.classList.add("focused");
            } else {
                ref.current?.querySelector(".field-fullAdress")?.classList.remove("focused");
            }
        }
    };

    const _clearProgress = () => {
        clearTimeout(timeout.current);
        timeout.current = setTimeout(() => {
            setLoading(false);
            setProgress(0);
        }, 1000);
    };

    const _stopProgress = () => {
        clearTimeout(timeout.current);
        setProgress(100);
        _clearProgress();
    };

    const _startProgress = async () => {
        setLoading(true);
        let i = 0;
        let progress = 0;

        const loop = () => {
            do {
                ++i;
                progress = progress + 2;
                setProgress(progress);
            } while (i == i + 1);

            if (i && progress <= 100) {
                timeout.current = setTimeout(loop, 100);
            }
        };

        loop();
    };

    useEffect(() => {
        const f = async () => {
            await getReservation(true);
        };

        f();

        // window.addEventListener("popstate", function (e) {
        //     var state = e.state;

        //     if (state !== null) {
        //         console.log(2);
        //         const f = async () => {
        //             const phone = searchParams.get("phone");
        //             let num = Number(phone);

        //             const response: any = await ReservationsService.getReservationsByPnone({
        //                 phone_number: num,
        //                 status: _.isEqual(Store.reservations.activeKey, "activation")
        //                     ? "activated"
        //                     : ""
        //             });

        //             const reservations = _.get(response, "items[0]");
        //             await Axios({
        //                 url: "/reservations/passport",
        //                 method: "PUT",
        //                 data: {
        //                     lastname: _.get(reservations, "phone.abonentPassport.firstname"),
        //                     firstname: _.get(reservations, "phone.abonentPassport.firstname"),
        //                     patroname: _.get(reservations, "phone.abonentPassport.patroname"),
        //                     birthday: _.get(reservations, "phone.abonentPassport.birthday"),
        //                     gender: _.get(reservations, "phone.abonentPassport.gender"),
        //                     birth_place_name: _.get(
        //                         reservations,
        //                         "phone.abonentPassport.birth_place_name"
        //                     ),
        //                     document_series: _.get(
        //                         reservations,
        //                         "phone.abonentPassport.document_series"
        //                     ),
        //                     passport_nomer: _.get(
        //                         reservations,
        //                         "phone.abonentPassport.passport_nomer"
        //                     ),
        //                     division_code: _.get(
        //                         reservations,
        //                         "phone.abonentPassport.division_code"
        //                     ),
        //                     passport_kogda_vidan: _.get(
        //                         reservations,
        //                         "phone.abonentPassport.passport_kogda_vidan"
        //                     ),
        //                     passport_vidan: _.get(
        //                         reservations,
        //                         "phone.abonentPassport.passport_vidan"
        //                     ),
        //                     place_name: _.get(reservations, "phone.abonentPassport.place_name"),
        //                     street_name: _.get(reservations, "phone.abonentPassport.street_name"),
        //                     house: _.get(reservations, "phone.abonentPassport.house"),
        //                     building_name: _.get(
        //                         reservations,
        //                         "phone.abonentPassport.building_name"
        //                     ),
        //                     apartment_name: _.get(
        //                         reservations,
        //                         "phone.abonentPassport.apartment_name"
        //                     ),
        //                     phone: _.get(reservations, "phone_number"),
        //                     status: "declined"
        //                 }
        //             } as IAxiosConfig);

        //             await getReservation(true);
        //         };

        //         f();
        //     } else {
        //         console.log(1);

        //         const f = async () => {
        //             await getReservation(true);
        //         };

        //         f();
        //     }
        // });
    }, []);

    return (
        <Typography as="div" className={`bl-verification-passport-photo`}>
            {loading2 && (
                <DefaultPortal>
                    <Loading />
                </DefaultPortal>
            )}

            <Title
                title={
                    loading
                        ? "Идет загрузка фотографии..."
                        : isVisible()
                        ? "Убедитесь в правильности данных"
                        : "Загрузите фото \nпаспорта"
                }
                subTitle={
                    loading
                        ? undefined
                        : "Для успешной идентификации вам необходимо загрузить цветные фотографии паспорта. \nУбедитесь, что на всех фото данные хорошо различимы. Допустимые форматы: jpg, jpeg, png."
                }
            />
            {loading && (
                <LionProgressbar value={progress} type="circle" progressColor="goldTexture" />
            )}

            {!loading && (
                <Form
                    form={form}
                    layout="horizontal"
                    onFinish={onFinish}
                    onValuesChange={onValuesChange}
                    autoComplete="off"
                >
                    <Typography as="div" className="container">
                        <Typography as="div" className="form-item-conteiner">
                            {passportFront && (
                                <Button type="text" className="plus remove">
                                    <PlusOutlined />
                                </Button>
                            )}

                            <Form.Item name="passport_front">
                                <Upload
                                    accept="image/jpeg,image/png"
                                    className="passport-front"
                                    customRequest={() => undefined}
                                    listType="picture-card"
                                    fileList={passportFront}
                                >
                                    {!passportFront && (
                                        <UploadBtn
                                            title={"Разворот \nс фотографией"}
                                            images={passportFrontImg}
                                        />
                                    )}
                                </Upload>
                            </Form.Item>
                        </Typography>
                        <Typography as="div" className="form-item-conteiner">
                            {passportReg && (
                                <Button
                                    type="text"
                                    className={
                                        !isPassportRegDisable()
                                            ? `plus remove`
                                            : `plus remove opasity`
                                    }
                                >
                                    <PlusOutlined />
                                </Button>
                            )}
                            <Form.Item
                                name="passport_reg"
                                className={isPassportRegDisable() ? "disabled" : ""}
                            >
                                <Upload
                                    accept="image/jpeg,image/png"
                                    className="passport-reg"
                                    customRequest={() => undefined}
                                    listType="picture-card"
                                    fileList={passportReg}
                                    disabled={isPassportRegDisable()}
                                >
                                    {!passportReg && (
                                        <UploadBtn
                                            title={"Разворот \nс регистрацией"}
                                            images={passportRegImg}
                                        />
                                    )}
                                </Upload>
                            </Form.Item>
                        </Typography>
                    </Typography>

                    {isVisible() && (
                        <div ref={ref} className="bl-support-search">
                            <Typography as="div" className="conteiner-form">
                                <Row gutter={[16, 0]}>
                                    <Col xs={24} md={8}>
                                        <InputField
                                            formItemProps={{
                                                name: "lastname",
                                                label: "Фамилия",
                                                rules,

                                                normalize: (value: string) =>
                                                    _.replace(value, /[^а-яА-Яa-zA-Z ]/gi, "")
                                            }}
                                        />
                                    </Col>
                                    <Col xs={24} md={8}>
                                        <InputField
                                            formItemProps={{
                                                name: "firstname",
                                                label: "Имя",
                                                rules,
                                                normalize: (value: string) =>
                                                    _.replace(value, /[^а-яА-Яa-zA-Z ]/gi, "")
                                            }}
                                        />
                                    </Col>
                                    <Col xs={24} md={8}>
                                        <InputField
                                            formItemProps={{
                                                name: "patroname",
                                                label: "Отчество",
                                                normalize: (value: string) =>
                                                    _.replace(value, /[^а-яА-Яa-zA-Z ]/gi, "")
                                            }}
                                        />
                                    </Col>

                                    <Col xs={24} md={12}>
                                        <Row gutter={[16, 16]}>
                                            <Col xs={12} lg={12}>
                                                <DatePickerField
                                                    formItemProps={{
                                                        name: "birthday",
                                                        label: "Дата рождения",
                                                        rules
                                                    }}
                                                    datePickerProps={datePickerProps}
                                                />
                                            </Col>
                                            <Col xs={12} lg={12} className="col-radio-group">
                                                <Typography as="div" className="sim-type">
                                                    <RadioField
                                                        name="gender"
                                                        items={[
                                                            {
                                                                filter: "m",
                                                                name: "Муж."
                                                            },
                                                            {
                                                                filter: "w",
                                                                name: "Жен."
                                                            }
                                                        ]}
                                                    />
                                                </Typography>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col
                                        xs={24}
                                        md={12}
                                        className="custom-select-nationality-container"
                                    >
                                        {/* <InputField
                                            formItemProps={{
                                                name: "nationality",
                                                label: "Гражданство",
                                                rules
                                            }}
                                        /> */}
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <InputField
                                            formItemProps={{
                                                name: "birth_place_name",
                                                label: "Место Рождения",
                                                rules,
                                                normalize: (value: string) =>
                                                    _.replace(value, /[^а-яА-Яa-zA-Z]/gi, "")
                                            }}
                                        />
                                    </Col>
                                    <Col
                                        xs={12}
                                        md={_.isEqual(data?.document_type, "domestic") ? 6 : 7}
                                    >
                                        {_.isEqual(data?.document_type, "domestic") ? (
                                            <InputField
                                                disabled={!!form.getFieldValue("document_series")}
                                                formItemProps={{
                                                    name: "document_series",
                                                    label: "Серия паспорта",
                                                    normalize: (value: string) => {
                                                        const updated = _.replace(
                                                            value,
                                                            /[^\d]/gi,
                                                            ""
                                                        );
                                                        const left = updated.substring(0, 2);
                                                        const right = updated.substring(2, 4);
                                                        return `${left}${
                                                            _.size(right) ? `${right}` : ""
                                                        }`;
                                                    },
                                                    rules: [
                                                        ...rules,
                                                        {
                                                            min: 4,
                                                            message:
                                                                "Поле должно содержать 4 символа"
                                                        }
                                                    ]
                                                }}
                                            />
                                        ) : (
                                            <InputField
                                                disabled={!!form.getFieldValue("passport_nomer")}
                                                formItemProps={{
                                                    name: "passport_nomer",
                                                    label: "Серия и номер паспорта",
                                                    normalize: (value: string) =>
                                                        _.replace(
                                                            value,
                                                            /[^a-zA-Z\d]/gi,
                                                            ""
                                                        ).substring(20, 0),

                                                    rules: [...rules]
                                                }}
                                            />
                                        )}
                                    </Col>
                                    {_.isEqual(data?.document_type, "domestic") && (
                                        <>
                                            <Col xs={12} md={6}>
                                                <InputField
                                                    disabled={
                                                        !!form.getFieldValue("passport_nomer")
                                                    }
                                                    formItemProps={{
                                                        name: "passport_nomer",
                                                        label: "Номер паспорта",
                                                        normalize: (value: string) => {
                                                            const updated = _.replace(
                                                                value,
                                                                /[^\d]/gi,
                                                                ""
                                                            );
                                                            const left = updated.substring(0, 3);
                                                            const right = updated.substring(3, 6);
                                                            return `${left}${
                                                                _.size(right) ? `${right}` : ""
                                                            }`;
                                                        },
                                                        rules: [
                                                            ...rules,
                                                            {
                                                                min: 6,
                                                                message:
                                                                    "Поле должно содержать 6 символов"
                                                            }
                                                        ]
                                                    }}
                                                />
                                            </Col>
                                            <Col xs={12} md={6}>
                                                <InputField
                                                    formItemProps={{
                                                        name: "division_code",
                                                        label: "Код подразделения",
                                                        normalize: (value: string) => {
                                                            const updated = _.replace(
                                                                value,
                                                                /[^\d]/gi,
                                                                ""
                                                            );
                                                            const left = updated.substring(0, 3);
                                                            const right = updated.substring(3, 6);
                                                            return `${left}${
                                                                _.size(right) ? `-${right}` : ""
                                                            }`;
                                                        },
                                                        rules: [
                                                            ...rules,
                                                            {
                                                                min: 7,
                                                                message:
                                                                    "Поле должно содержать 6 символов"
                                                            }
                                                        ]
                                                    }}
                                                />
                                            </Col>
                                        </>
                                    )}

                                    <Col
                                        xs={12}
                                        md={_.isEqual(data?.document_type, "domestic") ? 6 : 5}
                                    >
                                        <DatePickerField
                                            formItemProps={{
                                                name: "passport_kogda_vidan",
                                                label: "Дата выдачи",
                                                rules
                                            }}
                                            datePickerProps={datePickerProps}
                                        />
                                    </Col>

                                    <Col
                                        xs={24}
                                        md={_.isEqual(data?.document_type, "domestic") ? 12 : 24}
                                        className="custom-select-passport_vidan-container"
                                    >
                                        <InputField
                                            formItemProps={{
                                                name: "passport_vidan",
                                                label: "Выдан",
                                                rules
                                            }}
                                        />
                                    </Col>

                                    <Col xs={24} className="permanent-registration-address">
                                        <Row gutter={[12, 0]}>
                                            <Col span={24}>
                                                <Typography
                                                    as="div"
                                                    className="title-adress"
                                                    size={
                                                        _.gte(contextLayout?.width ?? 0, 431)
                                                            ? 24
                                                            : 17
                                                    }
                                                >
                                                    {"Адрес постоянной регистрации"}
                                                </Typography>
                                            </Col>
                                            {/* <Col span={24} className="left chb">
                                                <CheckboxField
                                                    name="handwrite"
                                                    items={[
                                                        {
                                                            name: "Активировать ручное редактирование адреса",
                                                            filter: "true"
                                                        }
                                                    ]}
                                                />
                                            </Col> */}
                                            <Col
                                                span={24}
                                                className={`can-hide ${handwrite ? "hide" : ""}`}
                                            >
                                                <AddressField
                                                    formItemProps={{
                                                        name: "fullAdress",
                                                        label: "Адрес"
                                                    }}
                                                    autoCompleteProps={{
                                                        popupClassName: "search-adress-select",
                                                        options,
                                                        allowClear: false,
                                                        onSearch
                                                        // notFoundContent: loadingAddress ? (
                                                        //   <Spin
                                                        //     className="bz-spinner"
                                                        //     indicator={<Image src={spinnerImg} alt="spinner" />}
                                                        //   />
                                                        // ) : null,
                                                    }}
                                                />
                                            </Col>

                                            <Col
                                                xs={24}
                                                md={24}
                                                className={`can-hide ${!handwrite ? "hide" : ""}`}
                                            >
                                                <InputField
                                                    formItemProps={{
                                                        name: "place_name",
                                                        label: "Населенный пункт",
                                                        normalize: (value: string) =>
                                                            _.replace(
                                                                value,
                                                                /[^а-яА-Яa-zA-Z]/gi,
                                                                ""
                                                            )
                                                    }}
                                                />
                                            </Col>
                                            <Col
                                                xs={24}
                                                md={12}
                                                className={`can-hide ${!handwrite ? "hide" : ""}`}
                                            >
                                                <InputField
                                                    formItemProps={{
                                                        name: "street_name",
                                                        label: "Улица",
                                                        normalize: (value: string) => {
                                                            return _.replace(
                                                                value,
                                                                /[^а-яА-Яa-zA-Z0-9\-\.\s]/gim,
                                                                ""
                                                            );
                                                        }
                                                    }}
                                                />
                                            </Col>
                                            <Col
                                                xs={8}
                                                md={4}
                                                className={`can-hide ${!handwrite ? "hide" : ""}`}
                                            >
                                                <InputField
                                                    formItemProps={{
                                                        name: "house",
                                                        label: "Дом",
                                                        // rules,
                                                        normalize: (value: string) => {
                                                            return _.replace(
                                                                value.substring(0, 6),
                                                                /[^а-яА-Яa-zA-Z0-9\-\.\s\|\\]/gim,
                                                                ""
                                                            );
                                                        }
                                                    }}
                                                />
                                            </Col>
                                            <Col
                                                xs={8}
                                                md={4}
                                                className={`can-hide ${!handwrite ? "hide" : ""}`}
                                            >
                                                <InputField
                                                    formItemProps={{
                                                        name: "building_name",
                                                        label: "Строение",
                                                        normalize: (value: string) => {
                                                            return _.replace(
                                                                value.substring(0, 6),
                                                                /[^а-яА-Яa-zA-Z0-9\-\.\s\|\\]/gim,
                                                                ""
                                                            );
                                                        }
                                                    }}
                                                />
                                            </Col>
                                            <Col
                                                xs={8}
                                                md={4}
                                                className={`can-hide ${!handwrite ? "hide" : ""}`}
                                            >
                                                <InputField
                                                    formItemProps={{
                                                        name: "apartment_name",
                                                        label: "Квартира",
                                                        normalize: (value: string) => {
                                                            return _.replace(
                                                                value.substring(0, 6),
                                                                /[^а-яА-Яa-zA-Z0-9\-\.\s\|\\]/gim,
                                                                ""
                                                            );
                                                        }
                                                    }}
                                                />
                                            </Col>
                                            <Col span={24} className="left chb">
                                                <CheckboxField
                                                    name="handwrite"
                                                    items={[
                                                        {
                                                            name: "Активировать ручное редактирование адреса",
                                                            filter: "true"
                                                        }
                                                    ]}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    {!_.isEqual(data?.document_type, "domestic") && (
                                        <Col span={24} className="col-imei-value">
                                            <Form.Item
                                                className="field-imei"
                                                name="imei"
                                                rules={[
                                                    ...rules,
                                                    {
                                                        min: 15,
                                                        message:
                                                            "Введите корректный IMEI (15- 16 цифр). Проверьте, набрав *#06# на телефоне."
                                                    }
                                                ]}
                                                normalize={(value: string) =>
                                                    _.replace(value, /\D/g, "").substring(0, 16)
                                                }
                                            >
                                                <Input
                                                    type={"numeric"}
                                                    inputMode={"numeric"}
                                                    autoComplete={"off"}
                                                    title={"IMEI"}
                                                    placeholder="IMEI"
                                                />
                                            </Form.Item>
                                            <Button
                                                className="btn-imei-info"
                                                icon={
                                                    <img
                                                        src={imeiSvg}
                                                        width={18}
                                                        alt=""
                                                        className="simpng"
                                                    />
                                                }
                                                onClick={onClickInfoImei}
                                            ></Button>
                                            {/* {context?.data! && (
                                                <Typography
                                                    className={"field-imei-errorTypography"}
                                                >
                                                    {globalError?.message}
                                                </Typography>
                                            )} */}
                                        </Col>
                                    )}
                                </Row>

                                <Form.Item noStyle shouldUpdate>
                                    {({getFieldsValue, getFieldsError}) => {
                                        const {
                                            phone,
                                            lastname,
                                            firstname,
                                            birthday,
                                            gender,
                                            nationality,
                                            birth_place_name,
                                            document_series,
                                            passport_nomer,
                                            division_code,
                                            passport_vidan,
                                            passport_kogda_vidan,
                                            place_name,
                                            street_name,
                                            house,
                                            country,
                                            agree,
                                            imei,
                                            series
                                        } = getFieldsValue();
                                        const errors = form
                                            .getFieldsError()
                                            .some((el: {errors: string | any}) => el.errors.length);

                                        const formIsCompleteImei =
                                            !!lastname &&
                                            !!firstname &&
                                            !!birthday &&
                                            !!gender &&
                                            !!birth_place_name &&
                                            !!passport_nomer &&
                                            !!passport_kogda_vidan &&
                                            !!imei &&
                                            !errors;

                                        const formIsComplete =
                                            !!lastname &&
                                            !!firstname &&
                                            !!birthday &&
                                            !!gender &&
                                            !!birth_place_name &&
                                            !!document_series &&
                                            !!passport_nomer &&
                                            !!passport_kogda_vidan &&
                                            !errors;

                                        return (
                                            <Button
                                                type={
                                                    _.isEqual(data?.document_type, "domestic")
                                                        ? !formIsComplete
                                                            ? "default"
                                                            : "primary"
                                                        : !formIsCompleteImei
                                                        ? "default"
                                                        : "primary"
                                                }
                                                htmlType="submit"
                                                disabled={
                                                    _.isEqual(data?.document_type, "domestic")
                                                        ? !formIsComplete
                                                        : !formIsCompleteImei
                                                }
                                                // onClick={onClickModal}
                                            >
                                                Продолжить
                                            </Button>
                                        );
                                    }}
                                </Form.Item>
                            </Typography>
                        </div>
                    )}
                </Form>
            )}
        </Typography>
    );
});
